import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Radio, Select, Modal } from "antd";
import verifybtn from "../../image/verifybtn.png";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import InputField from "../../common/htmlComponents/InputField";
import EmailField from "../../common/htmlComponents/EmailField";
import PhoneInput from "react-phone-input-2";
import VerifyOtpModal from "../../authentication/VerifyOtpModel";
import VerifyBankOtpModal from "../../authentication/VerifyBankOtpModal";

const BankDetailsVendor = ({
  VendorId,
  bankdetailId,
  setBankDetailId,
  gstVendorId,
  gstValue,
  CompanyId,
  setShowPaymentCollapse,
}) => {
  const { t } = useTranslation();
  // const VendorId = id ? atob(id) : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [gstNumber, setGstNumber] = useState([]);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [minutes, setMinutes] = useState(1);
  const [OTP, setOTP] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [checkFormValueChange, setCheckFormValueChange] = useState(false);
  const [checkVerificationDone, setCheckVerificationDone] = useState(false);
  const [stateChange, setStateChange] = useState(false);

  const stateChangeRef = useRef(false);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  // const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  console.log(CompanyId, "company");
  const formRef = useRef();
  const initialState = {
    person_name: null,
    email: null,
    phone_number: null,
    bankdetails: [
      {
        id: null,
        account_holder_name: null,
        account_number: null,
        bank_name: null,
        branch_name: null,
        ifsc_code: null,
        same_for_all_billing_addresses: false,
        gstn: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  useEffect(() => {
    const defaultCountryCode = "+91";
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        // const apiResponse = await getRequest("vendor/" + VendorId);
        const apiResponse = await getRequest(
          `vendor-bank-detail/?vendor=${VendorId}`
        );
        if (apiResponse.data.success) {
          // const {
          //   //unique_code,
          //   id,
          //   //company_payment_terms,
          //   ...filteredResponse
          // } = apiResponse.data.data;

          setState({
            // ...filteredResponse,
            phone_number: apiResponse.data.data?.phone_number
              ? apiResponse.data.data?.phone_number
              : "+91",
            email: apiResponse.data.data?.email
              ? apiResponse.data.data?.email
              : null,
            name: apiResponse.data.data?.name
              ? apiResponse.data.data?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,

                same_for_all_billing_addresses:
                  rest.same_for_all_billing_addresses
                    ? rest.same_for_all_billing_addresses
                    : false,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,
                id: rest?.id ? rest?.id : null,

                same_for_all_billing_addresses:
                  rest.same_for_all_billing_addresses
                    ? rest.same_for_all_billing_addresses
                    : false,
              };
            }
          );
          // formRef.current.setFieldsValue = {
          //   name: apiResponse.data.data?.name
          //     ? apiResponse.data.data?.name
          //     : null,
          //   phone_number: apiResponse.data.data?.phone_number
          //     ? apiResponse.data.data?.phone_number
          //     : defaultCountryCode,
          //   email: apiResponse.data.data?.email
          //     ? apiResponse.data.data?.email
          //     : null,
          // };

          setWeightSizeBankFieldValue(modifiedBankDetails);

          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        //setFormSubmitted(true);
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    const getGstVendorOnboarding = async () => {
      const defaultCountryCode = "+91";
      setapiloading(true);
      try {
        // const apiResponse = await getRequest("vendor/" + VendorId);
        const apiResponse = await getRequest(
          // `vendor-bank-detail/?vendor=${VendorId}`
          `vendor-bank-detail/bank-details-by-gst/?gst_no=${gstValue}`
        );
        if (apiResponse.data.success) {
          // const {
          //   //unique_code,
          //   id,
          //   //company_payment_terms,
          //   ...filteredResponse
          // } = apiResponse.data.data;
          console.log("apiResponseName", apiResponse.data.data[0]?.name);
          setState({
            // ...filteredResponse,
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,
                id: rest?.id ? rest?.id : null,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return rest;
            }
          );

          setWeightSizeBankFieldValue(modifiedBankDetails);

          console.log("apiResponseNameBelow", apiResponse.data.data[0]);
          formRef.current?.setFieldsValue({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
          });
          console.log("bankdetailIdSet", apiResponse?.data?.data[0]?.id);
          setBankDetailId(apiResponse?.data?.data[0]?.id);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          // const {
          //   //unique_code,
          //   id,
          //   //company_payment_terms,
          //   ...filteredResponse
          // } = apiResponse.data.data;
          console.log("apiResponseName", apiResponse);
          setState({
            // ...filteredResponse,
            phone_number: apiResponse.data.data?.phone_number
              ? apiResponse.data.data?.phone_number
              : "+91",
            email: apiResponse.data.data?.email
              ? apiResponse.data.data?.email
              : null,
            name: apiResponse.data.data?.name
              ? apiResponse.data.data?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,
                id: rest?.id ? rest?.id : null,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                // id,
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              // const { id, vendor,vendor_name, ...rest } = bankDetail;
              return {
                ...rest,
                id: rest?.id ? rest?.id : null,
              };
            }
          );
          formRef.current?.setFieldsValue({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
          });
          setWeightSizeBankFieldValue(modifiedBankDetails);
          setBankDetailId(null);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        //setFormSubmitted(true);
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    // if (VendorId !== null) {
    //   // getPaymentTerms();
    //   getVendorOnboarding();
    //   // getPaymentTerms();
    // }
    if (VendorId !== null && gstVendorId === null) {
      // if (keypersonId !== null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId, gstVendorId, t, gstValue]);
  useEffect(() => {
    setIsButtonDisabled(!isStateValid(state));
  }, [state]); // Recalculate whenever state changes
  useEffect(() => {
    GetGstNumber();
  }, [VendorId]);
  useEffect(() => {
    if (!stateChangeRef.current) {
      stateChangeRef.current = true;
      setStateChange(true);
    }
  }, [state]);
  const GetGstNumber = async (value) => {
    const apiResponse = await getRequest(
      `vendor-suppliers-billing-details/get-gstnumber-suppliers-detail/?vendor_id=${VendorId}&company_id=${CompanyId}`
    );
    console.log(apiResponse, "res");
    if (apiResponse.data.success) {
      setGstNumber(apiResponse.data.data);
    }
  };
  const isStateValid = (state) => {
    const { phone_number, email, name, bankdetails } = state;
    const phone =
      phone_number !== "+91" && /^\d{12}$/.test(phone_number)
        ? phone_number
        : null;
    const isValidEmail = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    console.log("phone_number", !phone, !isValidEmail, !name);
    // Check if required fields are filled
    if (!phone || !isValidEmail || !name) {
      return false;
    }

    // Ensure at least one valid bank detail exists
    const isValidBankDetail = bankdetails.some((bank) => {
      return (
        bank.account_holder_name &&
        bank.account_number &&
        bank.bank_name &&
        bank.branch_name &&
        bank.ifsc_code &&
        bank.gstn
      );
    });

    return isValidBankDetail;
  };
  // const handleFormChange = (changedValues, allValues) => {
  //   console.log("changedValues", changedValues);
  //   console.log("allValues", allValues);
  //   const fieldName = Object.keys(changedValues)[0]; // Get the changed field name
  //   const fieldValue = changedValues[fieldName]; // Get the new value of the changed field

  //   console.log("Changed Field:", fieldName);
  //   console.log("New Value:", fieldValue);

  //   setCheckFormValueChange(true);
  // };
  const handleBankInputChange = (field, e, index) => {
    let newBankArr = state.bankdetails;
    newBankArr[index][field] = e.target.value ? e.target.value : null;
    setStateChange(true);
    setState({ ...state, bankdetails: newBankArr });
  };
  const addBank = () => {
    let newBankArr = [
      ...state.bankdetails,
      {
        id: null,
        account_holder_name: null,
        account_number: null,
        bank_name: null,
        branch_name: null,
        ifsc_code: null,
        same_for_all_billing_addresses: false,
        gstn: null,
      },
    ];
    setCheckFormValueChange(true);
    setState({ ...state, bankdetails: newBankArr });
    setWeightSizeBankFieldValue(newBankArr);
  };

  const removeBank = async (lastIndex) => {
    let filterBankArr = state.bankdetails.filter(
      (item, index) => index !== lastIndex
    );
    setCheckFormValueChange(true);
    setState({ ...state, bankdetails: filterBankArr });
    setWeightSizeBankFieldValue(filterBankArr);
  };

  const setWeightSizeBankFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["account_holder_name" + objectKey] =
        objectValue.account_holder_name;
      fieldObject["account_number" + objectKey] = objectValue.account_number;
      fieldObject["bank_name" + objectKey] = objectValue.bank_name;
      fieldObject["branch_name" + objectKey] = objectValue.branch_name;
      fieldObject["ifsc_code" + objectKey] = objectValue.ifsc_code;
      fieldObject["same_for_all_billing_addresses" + objectKey] =
        objectValue.same_for_all_billing_addresses;
      fieldObject["gstn" + objectKey] = objectValue.gstn;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const handleSubmit = async () => {
    const payload = {
      email: state?.email || "",
      phone_number: state?.phone_number || "",
      name: state?.name || "",
      bankdetails:
        state.bankdetails &&
        state.bankdetails.every(
          (bank) =>
            bank.account_holder_name === null &&
            bank.account_number === null &&
            bank.bank_name === null &&
            bank.branch_name === null &&
            bank.ifsc_code === null
        )
          ? []
          : state.bankdetails,
    };
    try {
      setBtnLoading(true);

      let response;
      if (bankdetailId === null) {
        const url =
          VendorId !== null
            ? `vendor-bank-detail/${VendorId}/add-bank-details/`
            : `vendor-bank-detail/${gstVendorId}/add-bank-details/`;
        // response = await patchRequest(
        //   `vendor-bank-detail/${VendorId}/add-bank-details/
        // `,
        //   payload
        // );
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-bank-detail/${VendorId}/`
            : `vendor-bank-detail/${gstVendorId}/`;

        response = await patchRequest(url, payload);
        // response = await patchRequest(
        //   `vendor-bank-detail/${VendorId}/`,
        //   payload
        // );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          bankdetailId === null
            ? t("bankdetail_added_successfully")
            : t("bankdetail_updated_successfully")
        );
        // SuccessNotificationMsg(t("bankdetail_updated_successfully"));
        setStateChange(false);
        setCheckFormValueChange(false);
        stateChangeRef.current = false;
        console.log("bankdetailId", bankdetailId, response.data.data);
        bankdetailId
          ? setState({
              // ...filteredResponse,
              phone_number: response.data.data[0]?.phone_number
                ? response.data.data[0]?.phone_number
                : "+91",
              email: response.data.data[0]?.email
                ? response.data.data[0]?.email
                : null,
              name: response.data.data[0]?.name
                ? response.data.data[0]?.name
                : null,
              bankdetails: response.data.data.map((bankDetail) => {
                const {
                  vendor,
                  vendor_name,
                  phone_number_otp,
                  phone_verified,
                  phone_number,
                  email,
                  name,
                  ...rest
                } = bankDetail;
                return {
                  ...rest,

                  id: rest?.id ? rest?.id : null,
                };
              }),
            })
          : setState({
              // ...filteredResponse,
              phone_number: response.data.data?.bankdetails[0]?.phone_number
                ? response.data.data?.bankdetails[0].phone_number
                : "+91",
              email: response.data.data?.bankdetails[0].email
                ? response.data.data?.bankdetails[0].email
                : null,
              name: response.data.data?.bankdetails[0].name
                ? response.data.data?.bankdetails[0].name
                : null,
              bankdetails: response.data.data.bankdetails?.map((bankDetail) => {
                const {
                  vendor,
                  vendor_name,
                  phone_number_otp,
                  phone_verified,
                  phone_number,
                  email,
                  name,
                  ...rest
                } = bankDetail;
                return {
                  ...rest,

                  id: rest?.id ? rest?.id : null,
                };
              }),
            });
        setBankDetailId(response.data.data.bankdetails[0].id);
        setShowPaymentCollapse(true);
        // SuccessNotificationMsg();
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        //navigate("/employee");
      }
    } catch (error) {
      // ErrorNotificationMsg(
      //   VendorId === null
      //     ? t("error_in_adding_bankdetail")
      //     : t("error_in_updating_bankdetail")
      // );
      setBtnLoading(false);
    }
  };
  // const handleOptionChangehierarchy = (name, value) => {
  //   setState({ ...state, [name]: value });
  // };
  // const handleSameForAllBillingAddressesChange = (index, value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     bankdetails: prevState.bankdetails.map((bankdetail, i) => {
  //       if (i === index) {
  //         return { ...bankdetail, same_for_all_billing_addresses: value };
  //       }
  //       return bankdetail;
  //     }),
  //   }));
  // };

  // const handleSameForAllBillingAddressesChange = (field, value, index) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     bankdetails: prevState.bankdetails.map((bankdetail, i) => {
  //       if (i === index) {
  //         return { ...bankdetail, [field]: value };
  //       }
  //       return bankdetail;
  //     }),
  //   }));
  // };
  // const handleSameForAllBillingAddressesChange = (field, value, index) => {
  //   setState((prevState) => ({
  //    ...prevState,
  //     bankdetails: prevState.bankdetails.map((bankdetail, i) => {
  //       if (i === index) {
  //         return {...bankdetail, [field]: value.target.checked };
  //       }
  //       return bankdetail;
  //     }),
  //   }));
  // };

  const handleSameForAllBillingAddressesChange = (index, value) => {
    const newBankDetails = [...state.bankdetails];
    newBankDetails[index].same_for_all_billing_addresses = value;

    setState({ ...state, bankdetails: newBankDetails });
    setStateChange(true);
  };

  const handleCloneSelectChange = (field, value, index) => {
    let newFeatureArr = state.bankdetails;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = value;
      setState({ ...state, bankdetails: newFeatureArr });
      setStateChange(true);
    }
  };

  const handleSendOtpPhone = async () => {
    setIsModalOpenPhone(true);
    try {
      const payload = {
        phone_number: state?.phone_number ? state.phone_number : "",
      };
      const response = await postRequest(
        `vendor-bank-detail/phone-number-verify/?vendor_id=${VendorId}`,
        payload
      );
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      setVerificationResultContact("");
    }
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };

  const handleCancel = () => {
    setIsModalOpenPhone(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoading(false);
  };

  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };

  const phoneValidLength = state.phone_number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };

  const handlePhoneInputChange = (phone) => {
    // setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone_number: phone,
      phone_verified: false,
    }));
    // setVerificationResultContact("");
  };
  const handleBankEmailChange = (mail) => {
    // setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      email: mail,
    }));
    setStateChange(true);
    // setVerificationResultContact("");
  };
  const handlePersonChange = (person) => {
    // setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      name: person,
    }));
    setStateChange(true);
    // setVerificationResultContact("");
  };

  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/;

    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone();
    } else {
      ErrorNotificationMsg("Enter valid mobile number");
    }
  };
  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          autoComplete="off"
          ref={formRef}
          onValuesChange={() => setCheckFormValueChange(true)}
        >
          {state.bankdetails &&
            state.bankdetails.map((x, index) => {
              console.log("x 1 ", x, "index 1", index);
              return (
                <>
                  <Row
                    key={index}
                    // className="customcol"
                    gutter={[15]}
                    className="bank_details_sec"
                  >
                    <Col xs={24} sm={22} md={22} xl={22} xxl={22}>
                      <Row gutter={[16]}>
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            name={`account_holder_name` + index}
                            label={t("label_account_holder_name")}
                            rules={[
                              {
                                required: true,
                                pattern: /^[A-Za-z\s]+$/,
                                message: (
                                  <Trans>{t("Please Enter Valid Name")}</Trans>
                                ),
                              },
                              {
                                min: 3,
                                message: <Trans>{t("minlength_msg")}</Trans>,
                              },
                              {
                                max: 30,
                                message: (
                                  <Trans>{t("maxlength_personName")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <Input
                              className="cust-input"
                              placeholder={t("pl_account_holder_name")}
                              onChange={(value) =>
                                handleBankInputChange(
                                  "account_holder_name",
                                  value,
                                  index
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            name={`account_number` + index}
                            label={t("label_account_number")}
                            rules={[
                              {
                                required: true,
                                pattern: "^[0-9]{9,18}$",
                                message: "Please enter valid account number",
                              },
                            ]}
                          >
                            <Input
                              className="cust-input"
                              placeholder={t("pl_account_number")}
                              onChange={(value) =>
                                handleBankInputChange(
                                  "account_number",
                                  value,
                                  index
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            name={`bank_name` + index}
                            label={t("label_bank_name")}
                            rules={[
                              {
                                required: true,
                                pattern: /^[A-Za-z\s]+$/,
                                message: (
                                  <Trans>{t("Please Enter Valid Name")}</Trans>
                                ),
                              },
                              {
                                min: 3,
                                message: <Trans>{t("minlength_msg")}</Trans>,
                              },
                              {
                                max: 30,
                                message: (
                                  <Trans>{t("maxlength_designation")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <Input
                              className="cust-input"
                              placeholder={t("pl_bank_name")}
                              onChange={(value) =>
                                handleBankInputChange("bank_name", value, index)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            name={`branch_name` + index}
                            label={t("label_branch_name")}
                            rules={[
                              {
                                required: true,

                                message: (
                                  <Trans>
                                    {t("Please Enter Valid Branch Name")}
                                  </Trans>
                                ),
                              },
                              {
                                min: 3,
                                message: <Trans>{t("minlength_msg")}</Trans>,
                              },
                              {
                                max: 30,
                                message: (
                                  <Trans>{t("maxlength_designation")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <Input
                              className="cust-input"
                              placeholder={t("pl_branch_name")}
                              onChange={(value) =>
                                handleBankInputChange(
                                  "branch_name",
                                  value,
                                  index
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Form.Item
                            name={`ifsc_code` + index}
                            label={t("label_ifsc_code")}
                            rules={[
                              {
                                required: true,

                                message: (
                                  <Trans>
                                    {t("Please Enter Valid IFSC Code")}
                                  </Trans>
                                ),
                              },
                              {
                                min: 3,
                                message: <Trans>{t("minlength_msg")}</Trans>,
                              },
                              {
                                max: 30,
                                message: (
                                  <Trans>{t("maxlength_designation")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <Input
                              className="cust-input"
                              placeholder={t("pl_ifsc_code")}
                              onChange={(value) =>
                                handleBankInputChange("ifsc_code", value, index)
                              }
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          xl={6}
                          xxl={6}
                          className="TextFeild gutter-row"
                        >
                          <Space align="center">
                            <Form.Item
                              className="radioitem radio2"
                              //name="same_for_all_billing_addresses"
                              // name={`same_for_all_billing_addresses_${index}`}
                              name={`same_for_all_billing_addresses` + index}
                              label="Same For All Billing Addresses"
                              initialValue={false}
                            >
                              <Radio.Group
                                value={
                                  state.bankdetails[index]
                                    .same_for_all_billing_addresses
                                }
                                onChange={(e) =>
                                  handleSameForAllBillingAddressesChange(
                                    index,
                                    e.target.value
                                  )
                                }
                              >
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Space>
                        </Col>
                        <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                          <Form.Item
                            // name={`gstn_${index}`}
                            name={`gstn` + index}
                            label={t("GSTN")}
                            // value={state.material_type}
                            // initialValue={x.material_type}
                            rules={[
                              {
                                required: true,
                                message: <Trans>{t("Select GSTN")}</Trans>,
                              },
                            ]}
                          >
                            <Select
                              showArrow
                              showSearch
                              // value={x.material_type}
                              allowClear
                              placeholder={t("Select GSTN")}
                              //   onChange={(value) =>
                              //     handleGstChange(index, value)
                              // }
                              onChange={(value) =>
                                handleCloneSelectChange("gstn", value, index)
                              }
                              // onChange={(value) =>
                              //   handleMaterialChange(index, value)
                              // }
                              optionFilterProp="children"
                            >
                              {gstNumber &&
                                gstNumber.length > 0 &&
                                gstNumber.map((item) => (
                                  <Select.Option
                                    key={item.gst_number}
                                    value={item.gst_number}
                                  >
                                    {item.gst_number}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24} sm={2} md={2} xl={2} xxl={2}>
                      <div className="addwrp">
                        <Space>
                          {index !== 0 ? (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removeBank(index)}
                            />
                          ) : (
                            ""
                          )}

                          {!x.same_for_all_billing_addresses ? (
                            <PlusSquareFilled
                              className="add"
                              onClick={(e) => addBank(e)}
                            />
                          ) : (
                            ""
                          )}
                        </Space>
                      </div>
                      <Modal
                        className="ModelPopupSec"
                        title={"Verify Mobile"}
                        open={isModalOpenPhone}
                        onOk={handleCancel}
                        onCancel={handleCancel}
                        closable={handleCancel}
                        wrapClassName="modal-wrapper"
                        keyboard={false}
                      >
                        <VerifyBankOtpModal
                          handleCancel={handleCancel}
                          setVerifyEmailButtonView={setVerifyEmailButtonView}
                          OTP={OTP}
                          setOTP={setOTP}
                          state={state}
                          setState={setState}
                          setMinutes={setMinutes}
                          setSeconds={setSeconds}
                          seconds={seconds}
                          minutes={minutes}
                          VendorId={VendorId}
                          setVerificationResultEmail={
                            setVerificationResultEmail
                          }
                          setCheckVerificationDone={setCheckVerificationDone}
                          checkVerificationDone={checkVerificationDone}
                          setCheckFormValueChange={setCheckFormValueChange}
                          handleSubmitVendor={handleSubmit}
                        />
                      </Modal>
                    </Col>
                  </Row>
                </>
              );
            })}
          <h6>Responsible Person for Bank Details Modification:</h6>
          <Row gutter={[16]}>
            <Col
              xs={24}
              sm={12}
              md={8}
              xl={6}
              xxl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="name"
                label={t("label_person_name")}
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: <Trans>{t("Please enter valid person name")}</Trans>,
                  },
                  {
                    required: true,

                    message: <Trans> {t("val_person_name")}</Trans>,
                  },
                ]}
              >
                <Input
                  value={state?.name}
                  className="cust-input"
                  placeholder={t("pl_person_name")}
                  onChange={(e) => handlePersonChange(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={8}
              xl={6}
              xxl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="email"
                label={t("label_email")}
                rules={[
                  {
                    required: true,

                    message: <Trans> {t("val_email")}</Trans>,
                  },
                ]}
              >
                <Input
                  value={state?.email}
                  className="cust-input"
                  placeholder={t("pl_email_2")}
                  onChange={(e) => handleBankEmailChange(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6} xl={6} xxl={6}>
              <div className="verifywrap">
                <Form.Item
                  name="phone_number"
                  label={t("label_mobileNumber")}
                  placeholder={t("pl_mobileNumber")}
                  rules={[
                    {
                      required: true,
                      validator: validatePhoneNumber,
                      message: <Trans> {t("val_mobileNumber")}</Trans>,
                    },
                  ]}
                >
                  <div className="verifywrap">
                    <div className="phonefield">
                      <PhoneInput
                        className="PhoneSection"
                        country={"in"}
                        value={state.phone_number}
                        onChange={(value) => handlePhoneInputChange(value)}
                      />
                    </div>
                  </div>
                </Form.Item>

                {verificationResultContact === "success" && (
                  <img
                    src={verifybtn}
                    style={{ height: "36px", marginTop: "29px" }}
                  ></img>
                )}
              </div>
            </Col>
          </Row>
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
              {" "}
              {/* <ButtonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                /> */}
              {verifyGstButtonView === true && bankdetailId !== null ? (
                <ButtonField
                  type="primary"
                  icon={<SaveOutlined />}
                  // className="primary"
                  // onClick={handleSubmit}
                  onClick={
                    checkFormValueChange &&
                    // !checkVerificationDone &&
                    stateChange
                      ? handleSendOtpPhone
                      : handleSubmit
                  }
                  // htmlType="Submit"
                  label={
                    checkFormValueChange &&
                    // !checkVerificationDone &&
                    stateChange
                      ? t("VerifyOtp & Save")
                      : t("Save")
                  }
                  loading={btnLoading}
                  disabled={isButtonDisabled} // Button is disabled based on state
                />
              ) : (
                <ButtonField
                  type="primary"
                  icon={<SaveOutlined />}
                  // className="primary"
                  // onClick={handleSubmit}
                  onClick={handleSubmit}
                  // htmlType="Submit"
                  label={t("Save")}
                  loading={btnLoading}
                  disabled={isButtonDisabled} // Button is disabled based on state
                />
              )}
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </>
  );
};
BankDetailsVendor.propTypes = {
  VendorId: PropTypes.number,
  bankdetailId: PropTypes.func,
  setBankDetailId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  CompanyId: PropTypes.number,
  setShowPaymentCollapse: PropTypes.func,
};
export default BankDetailsVendor;
